export enum StorageKeyEnum {
  ACCESS_TOKEN = "access-token",
  REFRESH_TOKEN = "refresh-token",
  LANGUAGE = "language",
  USER_DATA = "user-data",
  LAST_ACTIVE_ORGANISATION_PER_USER = "last-active-organisation-per-user",
  THEME = "theme",
}
